import { render, staticRenderFns } from "./MemorialPageSettings.vue?vue&type=template&id=7452aeec&scoped=true"
import script from "./MemorialPageSettings.vue?vue&type=script&lang=js"
export * from "./MemorialPageSettings.vue?vue&type=script&lang=js"
import style0 from "./MemorialPageSettings.vue?vue&type=style&index=0&id=7452aeec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7452aeec",
  null
  
)

export default component.exports